import type { DesignTemplateResponse } from '@mathflat/domain/@entities/DesignTemplate/api'
import type { DesignTemplate } from '@mathflat/domain/@entities/DesignTemplate/dto'
import type { PrintDocumentCoverDataT } from '@mathflat/domain/@entities/PrintDocument/type'

import { WorkbookDesignTemplate } from './WorkbookCoverDesignTemplate'

export class CustomPrintDesignTemplate extends WorkbookDesignTemplate<PrintDocumentCoverDataT> {
  constructor(
    data: DesignTemplate<PrintDocumentCoverDataT> | DesignTemplateResponse<PrintDocumentCoverDataT>,
  ) {
    super(data)
  }
}
